export default function FAQAccordionItem({ headingId, collapseId, title, ParentId, ChildComponent, key }) {

    return (
        <div key={key} className="accordion-item" >
            <h5 className="accordion-header" id={headingId}>
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#flush-${collapseId}`} aria-expanded="false" aria-controls={`flush-${collapseId}`} >
                    {title}
                </button>
            </h5>
            <div id={`flush-${collapseId}`} className="accordion-collapse collapse" aria-labelledby={headingId} data-bs-parent={`#${ParentId}`} >
                <div className="accordion-body container">
                    {ChildComponent}
                </div>
            </div>
        </div>
    )
}